import { render, staticRenderFns } from "./SearchCctr.vue?vue&type=template&id=0cf3245e&"
import script from "./SearchCctr.vue?vue&type=script&lang=js&"
export * from "./SearchCctr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports